var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.279 6.772a.814.814 0 010-1.1L5.392.228a.7.7 0 011.034 0l5.113 5.444a.814.814 0 010 1.1.7.7 0 01-1.033 0L5.91 1.878 1.312 6.772a.7.7 0 01-1.033 0z",
    fill: "#222"
  })));
};

export default SvgArrowUp;